import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import CalendarPicker from "rc-calendar";
import Letters from '../../Elements/Letters/Letters';
import Dropdown from '../Dropdown';
import RightMenu from "../RightMenu";
import RightIconMenu from "../RightIconMenu";

export default class View_type_19 extends Component {
	constructor(props) {
		super(props);

		var data = { list: [],artists:[], letters:[],prev_dropdown:[], title: '', ...props.data };
		this.state = {
			data: data,
			width: 0,
			height: 0,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
		};
		//console.log("View_type_19: ", this.state);
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}
	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener("resize", this.updateWindowDimensions);
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);
	}
	updateWindowDimensions() {
		this.setState(() => {
			return {
				width: window.innerWidth,
				heigth: window.innerHeight
			};
		});
	}
	render() {
		//console.log("    <h1>{this.state.data.title}</h1>", this.state.data.title);
		var object = this.state.data;
		// console.log("object2312323", object);
		/*
		check whether {object} is an array
		*/
    const {title} = this.props

			return (
				<div className="vt3">
					<div className="vt3 col-xs-12 col-sm-12 col-md-12 col-lg-9">
						<div className="vt14-list-block links_underline">
              <h2 className="vt14--title">
                {this.state.data.title}
              </h2>
              <p className="vt14--title vt14--title--2">
              {this.state.data.subtitle}
              </p>
							<div className="vt5 title-name artists-pageTitle">{object.header}</div>
							{object.list.map(function(news, index) {
								index++;
								var category = news.category;
								var title = news.title;
								var description = news.description;
								var color = news.color;
								var image = news.image;
								var url = news.url;
								if (index !== 0 && index % 3 === 0) {
									return (
										// <div key={index} className="small--inline">
											<div key={index} className="vt13--wrapped-item col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="vt14--bg"
                          style={{
                            backgroundImage: `url(${image})`
                          }}
                          ></div>
												<div className="vt14-middle-postblock">
													<div className="vt3 middle-thumbnailholder">
														{/* <img className="vt3-img" src={image} alt="" /> */}
														<div className="vt3 middlepost-thumbnail" />
														<div
															className="vt3 load-element"
															style={{ backgroundColor: color }}
														/>
													</div>
													{/* <p
														className="vt3 middlepost-titldesc"
														dangerouslySetInnerHTML={{
															__html: category.toUpperCase()
														}}
													/> */}
													<p
														className="vt3 middlepost-titleitem"
														dangerouslySetInnerHTML={{ __html: title }}
													/>
													<p
														className="vt3 middlepost-description"
														dangerouslySetInnerHTML={{ __html: description }}
													/>
													<div className="vt3 middle-addelem">
														<Link className="vt3 more_button" to={"/" + url} aria-label="hyperlink"/>
													</div>
												</div>
											</div>
									);
								}
								return (
									<div
										className="vt13--wrapped-item col-xs-12 col-sm-12 col-md-6 col-lg-6"
										key={index}
									>
                    <div className="vt14--bg"
                      style={{
                        backgroundImage: `url(${image})`
                      }}
                      ></div>
										<div className="vt4-middle-postblock">
											<div className="vt3 middle-thumbnailholder">
												{/* <img className="vt3-img" src={image} alt="" /> */}
												<div className="vt3 middlepost-thumbnail" />
												<div
													className="vt3 load-element"
													style={{ backgroundColor: color }}
												/>
											</div>
											{/* <p
												className="vt3 middlepost-titldesc"
												dangerouslySetInnerHTML={{
													__html: category.toUpperCase()
												}}
											/> */}
											<p
												className="vt3 middlepost-titleitem"
												dangerouslySetInnerHTML={{ __html: title }}
											/>
											<p
												className="vt3 middlepost-description"
												dangerouslySetInnerHTML={{ __html: description }}
											/>
											<div className="vt3 middle-addelem">
												<Link className="vt3 more_button" to={"/" + url} aria-label="hyperlink"/>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
          <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
    				{this.state.data.right_menu && this.state.data.prev_dropdown.current!=2018 && (
    					<div className="vt2 RightMenu">
    						<Dropdown giveMeClassName={`${this.state.data.prev_dropdown.dates.length>5 ? 'festiwal--dropdown' : 'normal'}`} data={this.state.data.prev_dropdown} />
								<RightMenu data={this.state.data.right_menu}/>

    					</div>
    				)}
						{this.state.rightIconMenu &&
							<RightIconMenu data={this.state.rightIconMenu}/>
						}
    				<div className="vt6 right col-xs-3 col-sm-3 col-md-12 col-lg-12 ArtistsLettersDesktop">
    					{/* {this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null} */}
    					{this.state.data.letters.length ? <Letters data={this.state.data.letters}/> : null}
    				</div>
    			</div>
				</div>
			);

	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_19/index.js